import { ComputedRef, Ref, ref, watch } from 'vue';

export function usePrevious<T>(refToWatch: Ref<T> | ComputedRef<T>): Ref<T> {
  const refFirstValue = refToWatch.value;
  const previous: Ref<T> = ref(refFirstValue) as Ref<T>;

  watch(refToWatch, (_, val) => (previous.value = val));
  return previous;
}
